import { User } from "../store/slices/authSlice";
import { useTheme } from "react-native-paper";

export const getPrimaryColor = (user: User, is4Schools?: boolean) => {
	const { colors } = useTheme();
	if (user?.card?.institution === "FACULDADE REPUBLICANA")
		return colors.primaryRepublicana;
	if (is4Schools) return colors.figmaBackgroundColor;

	return colors.primary;
};
